import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'fr', 'es', 'ar', 'it'],
    lng: 'fr', // default language
    fallbackLng: ['en'], // fallback to English
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      allowMultiLoading: false,
      requestOptions: {
        cache: 'no-cache'
      }
    },

    ns: [
      'common', 'nav', 'auth', 'dashboard', 'alerts', 'devices', 
      'zones', 'map', 'schedules', 'workOrders', 'settings', 
      'errors', 'validation', 'tooltips', 'tables', 
      'admin_common', 'admin_users', 'admin_orgs'
    ],
    defaultNS: 'common',
    fallbackNS: ['common', 'errors'],

    detection: {
      order: ['localStorage', 'htmlTag', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      htmlTag: document.documentElement
    },

    // Handle missing keys
    saveMissing: false,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${ns}:${key} for language: ${lng}`);
      }
    },

    // React specific options
    react: {
      useSuspense: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em']
    },
  });

export default i18n;